<template>
  <div v-if="!isLoadWebhook" class="app-detail-container">
    <div class="breadcrumbs mb-40">
      <div class="breadcrumb">
        <router-link to="/console/app-list">
          <div class="btn-back">
            <el-icon>
              <arrow-left />
            </el-icon>
            {{ $t('breadcrumb.back') }}
          </div>
        </router-link>
      </div>
    </div>
    <div class="app-detail-card">
      <div class="app-detail-header">
        <div class="avatar">
          <img v-if="form.app_logo" :src="form.app_logo_xs" height="52" />
          <img v-else src="@/assets/images/ols-logo-cloude.png" height="52" />
        </div>
        <div class="title">
          {{ form.store_url_id }}
          <div class="status">
            {{ approved }}
          </div>
        </div>
        <el-button type="success" class="edit-app" @click="handleEditApp">
          Edit App
        </el-button>
      </div>
      <div class="app-detail-content">
        <div class="title">
          {{ $t('app_detail.basic_information') }}
        </div>
        <el-form
          :model="form"
          label-position="left"
          label-width="150px"
        >
          <el-form-item label="App ID" class="mb-8">
            <span class="font-w-semi-bold">
              {{ form.app_id }}
            </span>
          </el-form-item>
          <el-form-item label="Store ID" class="mb-8">
            <span class="font-w-semi-bold">
              {{ form.openapi_id }}
            </span>
          </el-form-item>
          <el-form-item label="App Category" class="input-app-category mb-8">
            <el-select
              v-model="form.category_id"
              placeholder="Select catgeory"
              style="width:100%;"
              disabled>
              <el-option
                v-for="item in form.categories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="App Tag" class="mb-8">
            <div v-for="(item, index) in form.tag_selected" :key="index">
              <el-tag class="mr-6" type="info" size="small">{{ item.label }}</el-tag>
            </div>
          </el-form-item>
          <el-form-item label="API Call Limit" class="mb-8">
            <span class="font-w-semi-bold"> - </span>
          </el-form-item>
          <el-form-item label="App Service Region" class="mb-8">
            <span class="font-w-semi-bold">Indonesia</span>
          </el-form-item>
          <el-form-item label="Account Information" class="mb-8">
            <span class="font-w-semi-bold">
              {{ form.store_url_id }}
            </span>
          </el-form-item>
        </el-form>
      </div>
      <div class="app-detail-content">
        <div class="title">{{ $t('app_detail.app_key') }}</div>
        <el-form
          label-position="left"
          label-width="150px"
        >
          <el-form-item label="Secret key" class="secret_key mb-8">
            <el-input
              v-model="form.secret_key"
              type="text"
              readonly
            />
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.access_token" placeholder="Bearer Token">
              <template #append>
                <el-popover
                  ref="popover"
                  placement="left"
                  title=""
                  :width="20"
                  trigger="click"
                  content="Copied"
                >
                  <template #reference>
                    <el-button @click="copy">
                      {{ $t('app_detail.copy') }}
                    </el-button>
                  </template>
                </el-popover>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="loadToken"
              type="success"
              @click="getAccessToken">
              {{ $t('app_detail.get_token') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="app-detail-content">
        <div class="flex-container mb-16">
          <div class="font-18 font-w-bold flex-grow-1">Webhook</div>
          <el-dropdown v-if="isWebhook" trigger="click">
            <el-button size="default" style="background: #0000001f;">
              <img src="@/assets/icons/more-down.png" height="12" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showWebhook($t('webhook.wb_edit'))">
                  <el-icon :size="16">
                    <Edit />
                  </el-icon>
                  <span class="font-14 ml-4">Edit</span>
                </el-dropdown-item>
                <el-dropdown-item @click="handleWebhookUrl">
                  <el-icon :size="16">
                    <Link />
                  </el-icon>
                  <span class="font-14 ml-4">Check URL</span>
                </el-dropdown-item>
                <el-dropdown-item @click="dialogWebhookLog = true">
                  <el-icon :size="16">
                    <List />
                  </el-icon>
                  <span class="font-14 ml-4">Request Log</span>
                </el-dropdown-item>
                <el-dropdown-item @click="dialogWebhookChangeLog = true">
                  <el-icon :size="16">
                    <List />
                  </el-icon>
                  <span class="font-14 ml-4">Change Log</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <template v-if="isWebhook">
          <el-alert :closable="false" style="background: #E5F4FF;">
            <template #title>
              <span class="font-12 font-w-regular color-black">
                Callback URL
              </span>
            </template>
            <template #default>
              <span class="font-16 color-black">
                {{ form.webhook }}
              </span>
            </template>
          </el-alert>
          <div v-if="form.header_request" class="custom-header mt-16">
            <div class="font-16 font-w-semi-bold">Custom Header</div>
            <el-row v-for="(item, index) in form.header_request" :key="index" class="my-16">
              <el-col :span="8">
                <span class="font-14">{{ item.header }}</span>
              </el-col>
              <el-col :span="16">
                <span class="font-14 font-w-semi-bold">{{ item.value }}</span>
              </el-col>
            </el-row>
          </div>
        </template>
        <template v-else>
          <el-form :inline="true">
            <el-form-item style="margin-right: 16px;">
              <el-input
                v-model="form.access_token"
                :placeholder="$t('webhook.cb_not_set')"
                disabled
                readonly
                style="width: 455px;"
              />
            </el-form-item>
            <el-form-item style="margin-right: 0px;">
              <el-button
                :loading="loadToken"
                type="success"
                @click="showWebhook($t('webhook.wb_setting'))">
                {{ $t('webhook.wb_open') }}
              </el-button>
            </el-form-item>
          </el-form>
        </template>
      </div>
    </div>
    <webhook-setting
      v-if="dialogWebhook"
      :is-webhook="dialogWebhook"
      :title="titleWebhook"
      :data="form"
      @loadWebhook="loadWebhook"
      @simulateWebhoook="simulateWebhoook"
      @closeWebhook="closeWebhook"
    />
    <webhook-log
      v-if="dialogWebhookLog"
      :is-log="dialogWebhookLog"
      :app-id="route.query.id"
      @closeLog="closeLogWebhook"
    />
    <webhook-change-log
      v-if="dialogWebhookChangeLog"
      :is-log="dialogWebhookChangeLog"
      :app-id="route.query.id"
      @closeLog="closeChangeLogWebhook"
    />
    <webhook-simulate
      v-model="dialogSimulate"
      :is-error="errorWebhook"
      :response-webhook="responseWebhook"
    />
  </div>
  <loading-full-screen
    v-else
    :loadPage="isLoadWebhook"
  />
</template>

<script setup>
import {
  detailPairingStore,
  categoryApp,
  webhookCheckUrl
} from '@/api/endpoints/catalog/authOlsera.js'
import { ref, reactive, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { ArrowLeft, Edit, Link, List } from '@element-plus/icons-vue'
import loadingFullScreen from '@/components/layout/LoadingFullScreen.vue'
import webhookSetting from './components/_webhookSetting.vue'
import webhookSimulate from './components/_webhookSimulate.vue'
import webhookLog from './components/_webhookLog.vue'
import webhookChangeLog from './components/_webhookChangeLog.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const store = useStore()
const route = useRoute()
const router = useRouter()
const loadToken = ref(false)
const form = reactive({
  id: '',
  app_id: '',
  openapi_id: '',
  store_url_id: '',
  category_id: '',
  categories: [],
  tag_selected: [],
  secret_key: '',
  app_logo: '',
  app_logo_xs: '',
  access_token: store.getters['app/testBearerToken'],
  status: 'R',
  webhook: null,
  header_request: []
})
const isLoadWebhook = ref(false)
const dialogWebhook = ref(false)
const approved = computed(() => {
  if (form.status === 'A') {
    return 'Aproved'
  }
  return 'Not Aproved'
})
const isWebhook = computed(() => {
  if (form.webhook) {
    return true
  }
  return false
})
const dialogSimulate = ref(false)
const dialogWebhookLog = ref(false)
const dialogWebhookChangeLog = ref(false)
const errorWebhook = ref(false)
const responseWebhook = ref(null)
const titleWebhook = ref('')

onMounted(() => {
  getCategory()
  getDataDetailPairing()
})

const getAccessToken = () => {
  loadToken.value = true
  const params = {
    app_id: form.app_id,
    secret_key: form.secret_key
  }
  store.dispatch('app/fetchCollectionToken', params).then((response) => {
    form.access_token = response.data.access_token
    loadToken.value = false
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
    loadToken.value = false
  })
}
const getCategory = () => {
  categoryApp().then(response => {
    form.categories = response.data
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
  })
}
const getDataDetailPairing = () => {
  detailPairingStore(route.query).then((response) => {
    const data = response.data.data
    form.id = data.id
    form.app_id = data.app_id
    form.openapi_id = data.openapi_id
    form.store_url_id = data.store_url_id
    form.category_id = data.category_id
    form.secret_key = data.secret_key
    form.app_logo = data.app_logo
    form.app_logo_xs = data.app_logo_xs
    form.status = data.status
    form.webhook = data.webhook
    form.header_request = data.header_request
    if (data.tags) {
      data.tags.forEach(item => {
        form.tag_selected.push({
          value: item.name,
          label: item.name
        })
      })
    }
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
  })
}
const copy = () => {
  navigator.clipboard.writeText(form.access_token)
}
const handleEditApp = () => {
  router.push({ path: '/app-edit', query: { id: route.query.id }})
}
const handleWebhookUrl = () => {
  webhookCheckUrl(route.query.id).then(() => {
    ElMessage({
      type: 'success',
      message: t('webhook.cb_success')
    })
  }).catch(() => {
    ElMessage({
      type: 'error',
      message: t('webhook.cb_failed')
    })
  })
}
const showWebhook = (title) => {
  titleWebhook.value = title
  dialogWebhook.value = true
}
const closeWebhook = () => {
  dialogWebhook.value = false
}
const loadWebhook = (load) => {
  isLoadWebhook.value = load
}
const closeLogWebhook = () => {
  dialogWebhookLog.value = false
}
const closeChangeLogWebhook = () => {
  dialogWebhookChangeLog.value = false
}
const simulateWebhoook = (res) => {
  if (res.status === 200) {
    errorWebhook.value = false
    getDataDetailPairing()
  } else {
    errorWebhook.value = true
  }
  dialogSimulate.value = true
  responseWebhook.value = res
}
</script>
